module.exports = __webpack_public_path__ + "img/goods6_5.9610ce1a.jpg";